/*
 * Created Date: 16-08-2022, 2:14:11 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import {
	LOCAL_STORAGE,
	SESSION_STORAGE,
	getAuthTokenSession,
	getCurrentWorkspaceSession,
	getDataSession
} from '@Core/Helpers/Session'

// import { getAuthTokenSession } from '../Helpers/Session'

const excludeAuthenApi = ['/sanctum/csrf-cookie']
const authToken = async requestConfig => {
	const authToken = getAuthTokenSession()
	const { url, notAuth } = requestConfig
	if (excludeAuthenApi.includes(url) || notAuth) {
		return requestConfig
	}

	requestConfig.headers.Authorization = `Bearer ${authToken?.access_token}`

	const language = getDataSession(LOCAL_STORAGE, 'lng')
	if (language) {
		requestConfig.headers.language = language
	}
	const channel_id = getCurrentWorkspaceSession('id')
	if (channel_id) {
		requestConfig.headers.channel = channel_id
	}

	// const channel_id = getCurrentWorkspaceSession('id')
	// if (channel_id) {
	// 	requestConfig.headers.channel = channel_id
	// }

	return requestConfig
}

export const hasExamDb = async requestConfig => {
	const exam = getDataSession(SESSION_STORAGE, 'exam_detail')
	if (exam?.db_name && exam?.db_connection) {
		requestConfig.headers['exam-db'] = exam?.db_name
		requestConfig.headers['exam-connection'] = exam?.db_connection
	}
	if (exam?.sync_pgsql) {
		requestConfig.headers['sync-pgsql'] = 1
	}
	if (exam?.id) {
		requestConfig.headers['exam-id'] = exam.id
	}
	return requestConfig
}

export const hasScopeChannel = async requestConfig => {
	const currentChannelId = getCurrentWorkspaceSession('id')
	requestConfig.headers.channel = currentChannelId
	return requestConfig
}

export const globalApiMiddleware = {
	auth: authToken
}
